import { useParams } from "react-router-dom";

export const useIdParam = () => {
    const params = useParams();

    const idString = params.id;

    const numberId = Number(idString);

    return numberId;
};